import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginPopupVisible: false,
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    updateLoginPopupVisible: (state, action) => {
      return {
        ...state,
        loginPopupVisible: action.payload,
      };
    },
  },
});

export const { updateLoginPopupVisible } = loginSlice.actions;

export default loginSlice.reducer;
